import axiosInstance from './axiosConfig';

export interface SidebarUnreadCounts {
  notifications: number;
  clientChats: number;
}

export const getSidebarUnreadCounts = async (): Promise<SidebarUnreadCounts> => {
  try {
    // Add cache-busting parameter to prevent browser caching issues
    const timestamp = Date.now();
    const response = await axiosInstance.get(`/sidebar/unread-counts?_t=${timestamp}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching sidebar unread counts:', error);
    return { notifications: 0, clientChats: 0 };
  }
}; 